<template>
  <v-dialog v-model="dialog" persistent max-width="1000px">
    <v-card :loading="loading">
      <v-card-title>
        <span class="text-h5">Storico e dettagli</span>
      </v-card-title>
      <v-card-text>
        <v-container fluid>
          <v-row dense>
            <v-col cols="6">
              <h3>ATTUALE</h3>
              <v-simple-table dense class="mt-1">
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-right">GIACENZA</th>
                      <th class="text-right">QUANTITA'</th>
<!--                       <th class="text-center">LISTINO</th>
                      <th class="text-right">PREZZO L.</th>
                      <th class="text-right">PREZZO</th>
                      <th class="text-right">SCONTO</th>  -->
                      <th class="text-right"><v-badge dot title="Il valore è modificabile">ACQUISTO</v-badge></th>
                      <th class="text-right"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in attuale" :key="index">
                      <td class="text-right">{{ item.giacenza }}</td>
                      <td class="text-right">{{ item.quantita }}</td>
<!--                       <td class="text-center">{{ item.listino }}</td>
                      <td class="text-right">{{ item.prezzoL | euro }}</td>
                      <td class="text-right">{{ item.prezzo | euro }}</td>
                      <td class="text-right">{{ item.sconto | percento }}</td> -->
                      <td class="text-right">
                        <v-edit-dialog :return-value.sync="item.acquisto" large persistent cancel-text="Annulla" save-text="Salva" @save="onSaveAcquisto(item)">
                          {{ item.acquisto | euro }}
                          <template v-slot:input>
                            <div class="mt-4 text-h6">Prezzo acquisto</div>
                            <v-text-field v-model="item.acquisto" label="Valore" single-line autofocus :rules="[numerico]"></v-text-field>
                          </template>
                        </v-edit-dialog>
                      </td>
                      <td class="text-right"></td>
                    </tr>
                  </tbody>                
                </template>
              </v-simple-table>
            </v-col>
            <v-col cols="6"></v-col>   
            <v-col :cols="numeroColonneListini" class="mt-5">
              <h3>LISTINI</h3>
              <v-data-table :headers="headersPrezzi" :items="prezzi" dense hide-default-footer disable-sort>
                <template v-slot:[`header.prezzo`]="{ header }">
                  <v-badge dot title="Il valore è modificabile">{{header.text}}</v-badge>
                </template>
                <template v-slot:[`header.ricarico`]="{ header }">
                  <v-badge dot title="Il valore è modificabile">{{header.text}}</v-badge>
                </template>
                <template v-slot:[`item.prezzo`]="{ item }">
                  <v-edit-dialog :return-value.sync="item.prezzo" large persistent cancel-text="Annulla" save-text="Salva" @save="onSavePrezzo(item)">
                    <div>{{ item.prezzo | euro}}</div>
                    <template v-slot:input>
                      <div class="mt-4 text-h6">Prezzo listino</div>
                      <v-text-field v-model="item.prezzo" label="Valore" single-line autofocus :rules="[numerico]"></v-text-field>
                    </template>
                  </v-edit-dialog>
                </template>
                <template v-slot:[`item.ricarico`]="{ item }">
                  <v-edit-dialog :return-value.sync="item.ricarico" large persistent cancel-text="Annulla" save-text="Salva" @save="onSaveRicarico(item)">
                    <div>{{ item.ricarico | percento}}</div>
                    <template v-slot:input>
                      <div class="mt-4 text-h6">Ricarico</div>
                      <v-text-field v-model="item.ricarico" label="Valore" single-line autofocus :rules="[numerico]"></v-text-field>
                    </template>
                  </v-edit-dialog>
                </template>
                <template v-slot:[`item.prezzoSuggerito`]="{ item }">
                  <v-btn v-if="item.prezzoSuggerito && mostraSuggerito" small @click="copiaSuggerito(item)">{{ item.prezzoSuggerito | euro}}</v-btn>
                </template>
              </v-data-table>
              <h5>* = Listino ivato</h5>
            </v-col>
            <v-spacer></v-spacer> 
            <v-col cols="6" class="mt-5">
              <h3>ACQUISTI</h3>
              <v-simple-table dense class="mt-1">
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left">FORNITORE</th>
                      <th class="text-right">QUANTITA'</th>
                      <th class="text-right">PREZZO</th>
                      <th class="text-right">ULTIMO ACQUISTO</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item in fornitori" :key="item._id">
                      <td class="text-left">{{ item.fornitore.descrizione }}</td>
                      <td class="text-right">{{ item.quantita }}</td>
                      <td class="text-right">{{ item.prezzo | euro }}</td>
                      <td class="text-right">{{ item.data | date }}</td>
                    </tr>
                  </tbody>             
                </template>
              </v-simple-table>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click.stop="dialog = false">OK</v-btn>
      </v-card-actions>
    </v-card>
    <v-snackbar v-model="snackbar" :timeout="timeout" :color="snackColor">
      {{ snackText }}
      <template v-slot:action="{ attrs }">
        <v-btn  color="blue" text v-bind="attrs" @click="snackbar = false">
          OK
        </v-btn>
      </template>
    </v-snackbar>
  </v-dialog>  
</template>

<script>
  import _ from 'lodash'
  import configurazioni from '@/services/configurazioniService'
  import movimenti from '@/services/movimentiService'
  import prodotti from '@/services/prodottiService'
  export default {
    components: {

    },
    props: {
      cliente: Object,
      prodotto: Object,
      show: Boolean,
      prezzoAcquistoModificato: { type: Number, default: null },
      mostraSuggerito: { type: Boolean, default: false }
    },
    data () {
      return {
        fornitori: [],
        prezzi: [],
        vendite: [],
        listini: [],
        listinoAcquisto: null,
        attuale: [],
        dialog: false,
        loading: false,
        headersPrezzi: [],
        numerico: value => !isNaN(value) || 'Il valore deve essere numerico',
        snackbar: false,
        snackColor: '',
        snackText: '',
        timeout: 4000,
        numeroColonneListini: 5,
        locMostrasuggerito: false
      }
    },
    async mounted() {
      // this.locMostrasuggerito = this.mostraSuggerito && this.prezzoAcquistoModificato
      const conf = await configurazioni.getConfigurazione('listini')
      this.listini = conf.listini
      this.listinoAcquisto = conf.acquisto || { ivato: false }
      this.creaHeaders()
/*       this.headersPrezzi = [
        { text: 'LISTINO', value: 'listino', align: 'start' },
        { text: 'PREZZO', value: 'prezzo', align: 'end' }
      ]
      var that = this
      debugger
      if (this.locMostrasuggerito) {
        this.headersPrezzi.push({ text: 'SUGG.', value: 'prezzoSuggerito', align: 'start' })
      }
      this.headersPrezzi.push({ text: 'RICARICO', value: 'ricarico', align: 'end' }) */
    },
    watch: {
      async show(value) {
        if (value) {
          this.dialog = true
          await this.elaboraTabelle()
        }
      },
      async prezzoAcquistoModificato(value) {
        if (value && this.attuale) {
          this.locMostrasuggerito = this.mostraSuggerito && !!value
          this.numeroColonneListini = 6
          this.creaHeaders()

          this.loading = true
          const item = this.attuale[0]
          if (item && value !== item.acquisto) {
            item.acquisto = value
            await this.onSaveAcquisto(item, true)
          }
          
          this.loading = false
        }
      }
    },
    methods: {
      creaHeaders() {
        this.headersPrezzi = [
          { text: 'LISTINO', value: 'listino', align: 'start' },
          { text: 'PREZZO', value: 'prezzo', align: 'end' }
        ]
        if (this.locMostrasuggerito) {
          this.headersPrezzi.push({ text: 'SUGG.', value: 'prezzoSuggerito', align: 'start' })
        }
        this.headersPrezzi.push({ text: 'RICARICO', value: 'ricarico', align: 'end' })
      },
      async copiaSuggerito(item) {
        item.prezzo = item.prezzoSuggerito
        await this.onSavePrezzo(item)
      },
      async onSaveAcquisto(item, elaboraSuggerito) {
        const valore = isNaN(item.acquisto) ? '' : +parseFloat(item.acquisto).toFixed(2)
        await this.aggiornaPrezzo(item, valore, 'acquisto', elaboraSuggerito)
      },
      async onSavePrezzo(item) {
        const valore = isNaN(item.prezzo) ? '' : +parseFloat(item.prezzo).toFixed(2)
        await this.aggiornaPrezzo(item, valore)
      },
      async onSaveRicarico(item) {
        let valore = ''
        if (!isNaN(item.ricarico)) {
          const ricarico = +parseFloat((item.ricarico) / 100).toFixed(2)
          valore = item.acquisto * (ricarico + 1)
        }
        await this.aggiornaPrezzo(item, valore)
      },
      async aggiornaPrezzo(item, valore, tipoPrezzo = 'listino', elaboraSuggerito) {
        prodotti.clearCache()
        const idProdotto = _.get(this.prodotto,'appoggio.prodotto.id', _.get(this.prodotto, 'prodotto.codice', ''))
        // const valore = isNaN(item.prezzo) ? '' : +parseFloat(item.prezzo).toFixed(2)
        if (!idProdotto || ! valore) {
          this.snackColor = 'red accent-2'
          this.snackText = 'Il valore non è valido'
          this.snackbar = true
          return
        }
        // considero sempre codiceListino perchè la chiave è completa anche se cliente (es _L_codicexxx, _LT_tipoyyyy) o tipoCliente
        await prodotti.aggiornaPrezzo(tipoPrezzo, idProdotto, item.codiceListino, valore)
        await this.elaboraPrezzi(elaboraSuggerito)
        await this.elaboraAttuale()
        console.log('aggiorna prezzo', idProdotto)
        this.$emit('aggiornaPrezzo', { listino: item.codiceListino, valore, codice: idProdotto })
        this.snackColor = 'success'
        this.snackText = 'Il prezzo di listino è stato aggiornato'
        this.snackbar = true
      },      
      async elaboraTabelle() {
        this.loading = true
        await this.elaboraAttuale()
        await this.elaboraFornitori()
        await this.elaboraPrezzi()
        this.loading = false
      },
      async elaboraAttuale() {
        const attuale = []
        const p = this.prodotto
        const c = this.cliente
        const prodotto = await prodotti.getProdotto(p.prodotto.codice)
        const quantita = p.quantita ? +parseFloat(p.quantita).toFixed(2) : ''
        const acquisto = _.get(prodotto, 'magazzino.prezzoAcquisto', 0)
        const giacenza = _.get(prodotto, 'magazzino.giacenza', 0)
        const ivato = _.get(p, 'valore.listino.ivato', false)
        let prezzoL = +parseFloat(_.get(p, 'valore.prezzoNettoUnitario', 0)).toFixed(2)
        let prezzoV = +parseFloat(_.get(p, 'valore.importoNettoUnitario', 0)).toFixed(2)
        if (ivato) {
          prezzoL = +parseFloat(_.get(p, 'valore.prezzoUnitario', 0)).toFixed(2)
          prezzoV = +parseFloat(_.get(p, 'valore.importoUnitario', 0)).toFixed(2)
        }
																					
        const listino = _.get(p, 'valore.listino.descrizione', '')
        const scontoEuro = +(prezzoL - prezzoV).toFixed(2)
        const sconto = +((1 - prezzoV / prezzoL) * 100).toFixed(2)
        let ricarico = acquisto > 0 && prezzoV > 0 ? ((prezzoV - acquisto) / acquisto) * 100 : '---'

		if (ivato) {
          const iva = _.get(prodotto, 'aliquotaIva.valore', 22)
          const prz = prezzoV / (1 + iva / 100)
          ricarico = acquisto > 0 ? +(((prz - acquisto) / acquisto) * 100).toFixed(2) : '---'
        } 	  

        const riga = {
          quantita: quantita,
          listino: listino,
          prezzoL: prezzoL,
          prezzo: prezzoV,
          sconto: sconto,
          scontoEuro: scontoEuro,
          acquisto: acquisto,
          ricarico: ricarico,
          giacenza: giacenza
        }
        attuale.push(riga)
        this.attuale = attuale
      },
      async elaboraFornitori() {
        if (!this.prodotto) return
        const r = this.prodotto
        const mm = await movimenti.getMovimentiProdottoTipoCliente(r.prodotto.codice, null, 'acquisto')
        const fornitori = []
        for (let m of _.sortBy(mm.rows, 'data').reverse()) {
          const riga = {
            fornitore: m.anagrafica.fornitore,
            quantita: m.quantita,
            prezzo: +(m.valore / m.quantita).toFixed(2),
            data: m.data
          }
          fornitori.push(riga)
        }
        this.fornitori = fornitori
      },
      async elaboraPrezzi(elaboraSuggerito) {
        if (!this.prodotto) return
        var r = this.prodotto
        const listini = this.listini
        const prodotto = await prodotti.getProdotto(r.prodotto.codice)
        console.log('prodotto', prodotto)
        const acquisto = _.get(prodotto, 'magazzino.prezzoAcquisto', 0)
        const pp = prodotto.prezzo
        const prezzi = []
																									   
        for (let listino of listini) { // elenco listini
          let pz = pp[listino.codice]
          if (pz) {
            const base = pz.base ? +parseFloat(pz.base).toFixed(2) : 0
            let ricarico = acquisto > 0 && pz.base ? +(((base - acquisto) / acquisto) * 100).toFixed(2) : '---'
            const old = this.prezzi.find(x => x.codiceListino === listino.codice)
            var suggerito 
            if (old) {
              if (elaboraSuggerito) {
                const ricOld = +parseFloat((old.ricarico) / 100).toFixed(2)
                suggerito = acquisto * (ricOld + 1)              
              } else {
                suggerito = old.prezzoSuggerito
              }
            }

            if (listino.ivato && !this.listinoAcquisto.ivato) {
              const iva = _.get(r, 'aliquotaIva.valore', 22)
              const prz = base / (1 + iva / 100)
              ricarico = acquisto > 0 && pz.base ? +(((prz - acquisto) / acquisto) * 100).toFixed(2) : '---'
            }

            const ivato = listino.ivato ? '* ' : ''																	   
										  
            const prezzo = {
              codiceListino: listino.codice,
              listino: ivato + (listino.descrizione || listino.codice),
              prezzo:  pz.base  ? base : '',
              ricarico: ricarico,
              acquisto,
              prezzoSuggerito: suggerito
            }
            prezzi.push(prezzo)
          } else {
            const prezzo = {
              codiceListino: listino.codice,
              listino: listino.descrizione || listino.codice,
              prezzo: '',
              ricarico: '',
              acquisto
            }
            prezzi.push(prezzo)
          }
        }

        const elencoPrezzi = Object.keys(pp)
        for (let p of elencoPrezzi.filter(x => !listini.map(l => l.codice).includes(x))) {  // elenco prezzi speciali (no listini)
          let pz = pp[p]
          if (pz) {
            const listino = this.listini.find(x => x.codice === p)
            const ricarico = acquisto > 0 ? +(((pz.base - acquisto) / acquisto) * 100).toFixed(2) : '---'
            const prezzo = {
              codiceListino: p,
              listino: listino ? listino.descrizione : p,
              prezzo: +pz.base.toFixed(2),
              ricarico: ricarico,
              acquisto
            }
            prezzi.push(prezzo)
          }
        }
        this.prezzi = prezzi 
      }
    }
  }
</script>
